import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber5 = () => {
  return (
    <g>
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.03 11.7692a2.613 2.613 0 0 1 -2.7838-2.0362l1.2538-.4482a1.5052 1.5052 0 0 0 1.53 1.3574 1.3438 1.3438 0 0 0 1.4037-1.4961 1.2671 1.2671 0 0 0 -1.3-1.4033 1.3677 1.3677 0 0 0 -1.0586.4482h-1.1619l.2068-4.2451h4.292v1.208h-3.1756l-.1035 2.0254a2.1587 2.1587 0 0 1 1.3691-.4951 2.2726 2.2726 0 0 1 2.3242 2.4394 2.5983 2.5983 0 0 1 -2.7962 2.6456z" />
    </g>
  );
};

export default withIcon(IconNumber5);
